const Actions = {
	Clone: "Clone",
    Preview: "Preview",
    PleaseSelect: "Please Select"
};
export default Actions;
